import { useState } from 'react';
import classnames from 'classnames';

import style from './SelectButtonMenu.module.scss';

import { SelectButtonList } from '@components/SelectButtonList';

export interface SelectButtonMenuProps {
    title: string;
    disabled?: boolean;
    primaryActionDisabled?: boolean;
    dataTestList?: string;
    dataTestButton?: string;
    items: SelectButtonMenuItem[];
    onButtonClick?(): void;
}

export interface SelectButtonMenuItem {
    label: string;
    dataTest: string;
    isHighlighted?: boolean;
    onClick(): void;
}

export function SelectButtonMenu({
    title,
    items = [],
    disabled,
    primaryActionDisabled,
    dataTestButton,
    dataTestList,
    onButtonClick,
}: SelectButtonMenuProps) {
    const [isOpen, setIsOpen] = useState(false);

    const handleButtonClick = onButtonClick ?? toggleIsOpen;

    function toggleIsOpen() {
        setIsOpen(prev => !prev);
    }

    return (
        <div
            className={classnames([
                style.root,
                isOpen && style.open,
                !items.length && style.withoutItems,
                disabled && style.root_disable,
            ])}
        >
            <div
                className={classnames([style.button, primaryActionDisabled && style.button_disabled])}
                data-test={dataTestButton}
                data-testid={dataTestButton}
                onClick={isOpen || disabled || primaryActionDisabled ? undefined : handleButtonClick}
            >
                {title}
            </div>
            <div className={style.verticalLine} />
            <SelectButtonList
                disabled={disabled}
                isOpen={isOpen}
                dataTest={dataTestList}
                items={items}
                onOpenerClick={toggleIsOpen}
            />
        </div>
    );
}
